import { ActionableMessageCardStrings } from 'owa-actionable-message-v2';
import {
    actionInProgressMessage1,
    authenticationFlowAcknowledgeMessage,
    authenticationFlowAcknowledgeButtonText,
    defaultPlaceholderTextInput1,
    defaultPlaceholderNumberInput1,
    defaultPlaceholderDateInput1,
    defaultPlaceholderChoiceSetInput1,
    warningMessageForInvalidInput1,
    warningMessageForMissingRequiredInput1,
    genericError1,
} from '../strings/ActionableMessageCard.locstring.json';

import {
    warningMessageForInputNumberLessThanMin1,
    warningMessageForInputNumberMoreThanMax1,
    warningMessageForInputNumberNotNumeric1,
} from '../strings/NumberTextField.locstring.json';
import { warningMessageForRequiredField1 } from '../strings/CustomTextInput.locstring.json';
import { getCalendarStrings } from 'owa-datepicker-common';
import loc, { format } from 'owa-localize';

export default function createActionableMessageCardStrings(): ActionableMessageCardStrings {
    return {
        format: format,
        placeholder: {
            textInput: loc(defaultPlaceholderTextInput1),
            numberInput: loc(defaultPlaceholderNumberInput1),
            dateInput: loc(defaultPlaceholderDateInput1),
            choiceSetInput: loc(defaultPlaceholderChoiceSetInput1),
        },
        error: {
            generic: loc(genericError1),
        },
        warning: {
            invalidInput: loc(warningMessageForInvalidInput1),
            missingRequiredInput: loc(warningMessageForMissingRequiredInput1),
            inputNumberNotNumeric: loc(warningMessageForInputNumberNotNumeric1),
            inputNumberLessThanMin: loc(warningMessageForInputNumberLessThanMin1),
            inputNumberMoreThanMax: loc(warningMessageForInputNumberMoreThanMax1),
            requiredField: loc(warningMessageForRequiredField1),
        },
        information: {
            actionInProgress: loc(actionInProgressMessage1),
            authenticationFlowAcknowledgeMessage: loc(authenticationFlowAcknowledgeMessage),
            authenticationFlowAcknowledgeButtonText: loc(authenticationFlowAcknowledgeButtonText),
        },
        datePicker: {
            ...getCalendarStrings(),
            isRequiredErrorMessage: warningMessageForRequiredField1,
        },
    };
}
